import { mutatorAction } from 'satcheljs';
import { getAdManagementStore } from '../store/store';

export const setPublisherRejectedMessageClosedAction = mutatorAction(
  'setPublisherRejectedMessageClosedAction',
  (isPublisherRejectedMessageClosed: boolean) => {
    const adManagementStore = getAdManagementStore();
    adManagementStore.isPublisherRejectedMessageClosed = isPublisherRejectedMessageClosed;
  }
);
